import { getFetchedDataPayload } from '../../../../../utils/fetched-data/get-fetched-data-payload';
import { loyaltyDomainStore } from '../../../store';
export const getMemberWatchlistFilms = () => {
    const watchlistFilms = getFetchedDataPayload(loyaltyDomainStore.data.memberWatchlistFilmsById);
    return watchlistFilms ? Object.values(watchlistFilms) : undefined;
};
